import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './context/context.css';
import App from './App';
import { ChakraProvider } from "@chakra-ui/react";
import { ThemeContextProvider } from './context/ThemeContext';
ReactDOM.render(
  <ThemeContextProvider>
    <ChakraProvider>
      <App />
    </ChakraProvider>
  </ThemeContextProvider>,
  document.getElementById('root')
);
